import { StudentBehaviorNoteNameFragment } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: StudentBehaviorNoteNameFragment) {
	return instance.id;
}

export const fieldSetLabels = {
	incidentType: "What type of incident was this?",
	motivation: "What was/were the student's possible motivation for doing this?",
	consequenceRec: "What is your suggested consequence?",
};

export const fieldLabels = {
	incidentTime: "When did this incident happen?",
	incidentLocation: "Where did this incident happen?",
	isIncidentPhysicalContactAggression: "Physical contact aggression",
	isIncidentFightingPhysicalAggression: "Fighting physical aggression",
	isIncidentVerbalAbuseDisrespectingStudent: "Verbal abuse disrespecting student",
	isIncidentDisrepectingTeacher: "Disrepecting teacher",
	isIncidentDisruption: "Disruption",
	isIncidentDefianceOrNonCompliance: "Defiance or non-compliance",
	isIncidentOther: "Other",
	incidentOther: "Describe",
	isMotivationAttentionSeeking: "Attention seeking",
	isMotivationReaction: "Reaction",
	isMotivationAnger: "Anger",
	isMotivationFrustration: "Frustration",
	isMotivationHabit: "Habit",
	isMotivationLackOfSelfContol: "Lack of self-contol",
	isMotivationOther: "Other",
	motivationOther: "Describe",
	isConsequenceRecDirectorIntervention: "Director intervention",
	isConsequenceRecSenOrSelIntervention: "SEN or SEL intervention",
	isConsequenceRecStudentServiceTeamIntervention: "Student service team intervention",
	isConsequenceRecParentContactFromReporter: "Parent contact from reporter",
	isConsequenceRecParentContactFromSchoolDirector: "Parent contact from school director",
	isConsequenceRecOther: "Other",
	consequenceRecOther: "Describe",
	additionalComments: "Additional comments",
};
